import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fc52cf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-item-template" }
const _hoisted_2 = { class: "GoodsItem" }
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "GoodsItem-center" }
const _hoisted_8 = {
  key: 0,
  style: {"width":"17px","height":"17px","margin-left":"4px"},
  alt: "",
  src: "https://static-s.theckb.com/BusinessMarket/Client/country/KoreaIconBorder@3x.png"
}
const _hoisted_9 = { style: {"font-size":"12px"} }
const _hoisted_10 = { style: {"font-size":"12px"} }


import { formatMoney } from '@/plugins/utils'
import { t } from '@/plugins/i18n'
import { useRoute, useRouter } from 'vue-router'
import PopBtn from '@/components/common/PopBtn.vue'
import GoodsItemAction from '@/components/common/GoodsItemAction.vue'
import LogoIcon from '@/components/common/LogoIcon.vue'
import GoodsLink from '@/components/common/GoodsLink.vue'
import { useStore } from 'vuex'
import { confirmLogin } from '@/util/useConfirm'
import { useRtfix, useSite2Station, isJA, isMultiStore } from '@/store'
import { formatMoneyDirection, calc, showCurrentUnit, calcJpyToRmb } from '@/util/useYan'
import { Site } from '@/common/const'
import { calType } from '@/common/utils'
import BlackMask from '@/components/BlackGoods/BlackMask.vue'
import { TaEvent, taTrack } from '@/util/buryingPoint'

export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: null
  },
  // 前端展示场景 1-搜索列表;2-猜你喜欢;3-店铺商品列表;4-商品详情;5-收藏;6-已购买;7-足迹;8-担当推荐;9-系统推荐;10-找相似;11-关联商品;12-市场爆款
  showChannel: {
    type: Number,
    default: null
  },
  // 是否显示限量
  showSellNum: {
    type: Boolean,
    default: true
  },
  //  是否展示国家icon，目前只有收藏的需要
  currencyCode: {
    type: String,
    default: ''
  },
  imgHeight: {
    type: String,
    default: '220px'
  },
  nameSize: {
    type: String,
    default: '16px'
  },
  priceSize: {
    type: String,
    default: '16px'
  }
},
  emits: ['unlike', 'cancelCollect', 'jump'],
  setup(__props, { emit: emits }) {

const props = __props
const router = useRouter()
const route = useRoute()

const store = useStore()
const stationCode = useSite2Station()





// 不喜欢操作回调
const unlike = (productCode: string) => {
  emits('unlike', productCode)
}

// 取消收藏操作回调
const cancelCollect = (productCode: string) => {
  emits('cancelCollect', productCode)
}

// 跳转至商品详情
const toDetail = () => {
  router.push(useRtfix('goods', { params: { id: props.item.productCode } }))
  // confirmLogin(() => {
  // }, () => {
  //   taTrack({
  //     event: TaEvent.PUPUP_WINDOW,
  //     value: {
  //       position: 'login',
  //       source: 'search_list_product_click'
  //     }
  //   })
  // })
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GoodsLink, {
      goods: __props.item,
      onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('jump')))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(PopBtn, { offset: "100%" }, {
            pop: _withCtx(() => [
              _createVNode(GoodsItemAction, {
                item: __props.item,
                showChannel: __props.showChannel,
                onUnlike: unlike,
                onCancelCollect: cancelCollect
              }, null, 8, ["item", "showChannel"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (_unref(store).getters.isLogin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", {
                        class: "GoodsItem-img",
                        style: _normalizeStyle(`height: ${__props.imgHeight};`)
                      }, [
                        _createVNode(_component_el_image, {
                          referrerPolicy: "no-referrer",
                          "data-goods": "",
                          class: "wrap",
                          src: __props.item.productMainImg,
                          alt: __props.item.productTitle,
                          fit: "cover",
                          lazy: ""
                        }, {
                          error: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 1
                        }, 8, ["src", "alt"])
                      ], 4)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", {
                        class: "GoodsItem-img",
                        style: _normalizeStyle(`height: ${__props.imgHeight};`),
                        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toDetail()), ["prevent","stop"]))
                      }, [
                        _createVNode(_component_el_image, {
                          referrerPolicy: "no-referrer",
                          "data-goods": "",
                          class: "wrap",
                          src: __props.item.productMainImg,
                          alt: __props.item.productTitle,
                          fit: "cover",
                          lazy: ""
                        }, null, 8, ["src", "alt"])
                      ], 4)
                    ])),
                _createVNode(BlackMask, {
                  type: "goods",
                  item: __props.item
                }, null, 8, ["item"])
              ])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            (__props.item.country === 'KR')
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : (_openBlock(), _createBlock(LogoIcon, {
                  key: 1,
                  class: "mr_5",
                  data: __props.item,
                  type: _unref(calType)(__props.item),
                  underline: __props.item.channel === 5,
                  country: __props.item.country
                }, null, 8, ["data", "type", "underline", "country"])),
            _createElementVNode("div", {
              class: "GoodsItem-center-name",
              style: _normalizeStyle(`font-size: ${__props.nameSize};`)
            }, _toDisplayString(_unref(isJA)() ? (__props.item.productTitleJp || __props.item.productTitle) : __props.item.productTitle), 5)
          ]),
          (__props.item.switchAllIncludePriceJp === 1 && _unref(isJA)())
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "GoodsItem-price",
                style: _normalizeStyle(`font-size: ${__props.priceSize};color: ${_unref(stationCode) === _unref(Site).KO ? '#333333' : 'red'};`)
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(formatMoney)(__props.item.allIncludePriceJp)) + "円", 1),
                _createElementVNode("span", _hoisted_9, "(" + _toDisplayString(_unref(calcJpyToRmb)(__props.item.allIncludePriceJp)) + "元)", 1)
              ], 4))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "GoodsItem-price",
                style: _normalizeStyle(`font-size: ${__props.priceSize};color: ${_unref(stationCode) === _unref(Site).KO ? '#333333' : 'red'};`)
              }, [
                _createElementVNode("span", null, _toDisplayString(`${__props.item.productSellPrice}${_unref(showCurrentUnit)(__props.item.country === 'KR')}`), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(`(${_unref(formatMoneyDirection)(_unref(calc)(__props.item.productSellPrice, __props.item.currency))
            })`), 1)
              ], 4)),
          _withDirectives(_createElementVNode("div", { class: "GoodsItem-sale" }, _toDisplayString(`${_unref(t)('销量')}：${__props.item.productSellQuantity}${_unref(t)('件')}`), 513), [
            [_vShow, __props.showSellNum && __props.item.productSellQuantity && __props.item.productSellQuantity !== -1]
          ])
        ])
      ]),
      _: 1
    }, 8, ["goods"])
  ]))
}
}

})